import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';
import React from 'react';

class ChipSelect extends React.Component {

    static propTypes = {
        handleChange: PropTypes.func.isRequired,
        classes: PropTypes.shape({
            root: PropTypes.string,
            clickable: PropTypes.string,
            deletable: PropTypes.string,
            avatar: PropTypes.string,
            avatarChildren: PropTypes.string,
            label: PropTypes.string,
        }),
        disabled: PropTypes.bool,
        className: PropTypes.string,
        chipClassName: PropTypes.string,
        activeClassName: PropTypes.string,
        disabledClassName: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            label: PropTypes.node.isRequired,
        })).isRequired,
    };

    static defaultProps = {
        // CSS overrides of material ui chip
        // @see https://material-ui.com/api/chip/
        classes: {},
        className: 'schnoffle-chip-container',
        chipClassName: 'schnoffle-chip-default',
        activeClassName: 'schnoffle-chip-selected',
        disabledClassName: 'schnoffle-chip-disabled',
        disabled: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            activeChipID: this.props.defaultChipID
                ? this.props.defaultChipID
                : null,
        };
    }

    handleChange = event => {
        const selectedChipID = event.target.parentElement.dataset.chipvalue;
        this.setState(Object.assign(
            {},
            this.state,
            { activeChipID: selectedChipID },
        ));
        this.props.handleChange(selectedChipID);
    };

    buildChips = () => {
        var Chips = this.props.data.map(chipdata => {
            const isSelected = chipdata.value == this.state.activeChipID;
            var activeClass = isSelected
                ? ` ${this.props.activeClassName}`
                : '';
            activeClass = this.props.disabled ?
                ` ${this.props.disabledClassName}`
                : activeClass;
            const classNames = `${this.props.chipClassName} ${activeClass}`;
            return (
                <Chip
                    key={chipdata.value}
                    data-chipvalue={chipdata.value}
                    label={chipdata.label}
                    clickable={!this.props.disabled}
                    onClick={this.props.disabled ? null : this.handleChange}
                    classes={Object.assign({}, { root: classNames }, this.props.classes)}
                />
            );
        });
        return Chips;
    };

    render() {
        return (
            <div className={this.props.className}>
                {this.buildChips()}
            </div>
        );
    }

}


export default ChipSelect;



// WEBPACK FOOTER //
// ./src/components/common/ChipSelect.js